export enum ClientNotificationTableColumns {
  applicationName = "applicationName",
  notificationType = "notificationType", 
  createdAt = "createdAt",
}

export const CLIENT_NOTIFICATION_TABLE_COLUMN_LABELS: Record<ClientNotificationTableColumns, string> = {
  [ClientNotificationTableColumns.applicationName]: "Application",
  [ClientNotificationTableColumns.notificationType]: "Type",
  [ClientNotificationTableColumns.createdAt]: "Created",
};

export const DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<ClientNotificationTableColumns, boolean> = {
  [ClientNotificationTableColumns.applicationName]: true,
  [ClientNotificationTableColumns.notificationType]: true,
  [ClientNotificationTableColumns.createdAt]: true,
};

export const DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_ORDER: ClientNotificationTableColumns[] = [
  ClientNotificationTableColumns.applicationName,
  ClientNotificationTableColumns.notificationType,
  ClientNotificationTableColumns.createdAt,
];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> => CLIENT_NOTIFICATION_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> => DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] => DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_ORDER;